module.exports = __webpack_public_path__ + "img/banner_jinniao.c49c8a27.png";